import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'project';

const projectMaterialService = {
  findProjects: (query) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/findProjects/${encodeURIComponent(String(query || ''))}`,
    });
  },

  createDocument: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/document`,
      data,
    });
  },

  checkReceiptItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/checkReceiptItem`,
      data,
    });
  },

  checkAlreadyIssuedItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/checkAlreadyIssuedItem`,
      data,
    });
  },
};

export default projectMaterialService;
